var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[(_vm.$slots.header)?_vm._t("header"):_c('x-header'),_vm._t("body"),(_vm.$slots.footer)?_vm._t("footer"):_c('x-footer'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }